@if (filteredEmployees) {
  <div class="page-root">
    <mat-card>
      <mat-card-header>
        <mat-card-title>{{ "form.label.location_filter" | transloco }}</mat-card-title>
      </mat-card-header>

      <mat-card-content class="column-stretch">
        <mat-form-field>
          <mat-label>{{ "form.label.location_filter" | transloco }}</mat-label>
          <mat-select [formControl]="locationFilterFormControl" (valueChange)="changeFilter($event)">
            @for (locationFilter of locationFilters; track $index) {
              <mat-option [value]="locationFilter">{{ locationName(locationFilter) }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </mat-card-content>
    </mat-card>

    <mat-card>
      <mat-card-header class="row-space-between">
        <mat-card-title>{{ "employee.title" | transloco }}</mat-card-title>

        <div class="card-action" (click)="add()">
          <mat-icon> add_circle</mat-icon>
          <mat-label>{{ "employee.add_employee" | transloco }}</mat-label>
        </div>
      </mat-card-header>

      <mat-card-content>
        <mat-table [dataSource]="filteredEmployees" cdkDropList (cdkDropListDropped)="reorder($event)"
                   class="width-none" #table>
          <ng-container matColumnDef="firstname">
            <mat-header-cell *matHeaderCellDef>{{ "form.label.first_name" | transloco }}</mat-header-cell>
            <mat-cell *matCellDef="let employee" class="row-gap-small-center">
              <mat-icon class="no-shrink">reorder</mat-icon>
              <div>{{ employee.firstName }}</div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="lastname">
            <mat-header-cell *matHeaderCellDef>{{ "form.label.last_name" | transloco }}</mat-header-cell>
            <mat-cell *matCellDef="let employee">{{ employee.lastName }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="canbook">
            <mat-header-cell *matHeaderCellDef>{{ "employee.can_book.title" | transloco }}</mat-header-cell>
            <mat-cell *matCellDef="let employee">
              @if (employee.canBook) {
                <div>{{ "label.yes" | transloco }}</div>
              } @else {
                <div>{{ "label.no" | transloco }}</div>
              }
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="link">
            <mat-header-cell *matHeaderCellDef>{{ "form.label.direct_url" | transloco }}</mat-header-cell>
            <mat-cell *matCellDef="let employee">
              @if (employee.locationIds && employee.locationIds.length > 0) {
                <button mat-icon-button [matMenuTriggerFor]="locationMenu">
                  <mat-icon>link</mat-icon>
                </button>
                <mat-menu #locationMenu="matMenu">
                  @for (location of getEmployeeLocations(employee); track $index) {
                    <button mat-menu-item (click)="copyUrl(location.locationId, employee.employeeId)">{{ locationName(location.locationId) }}</button>
                  }
                </mat-menu>
              }
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let employee" class="row-end">
              <button mat-icon-button (click)="edit(employee)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button (click)="delete(employee)">
                <mat-icon>delete</mat-icon>
              </button>
            </mat-cell>
          </ng-container>

          <mat-header-row
            *matHeaderRowDef='["firstname", "lastname", "canbook", "link", "actions"]'></mat-header-row>
          <mat-row *matRowDef='let employee columns: ["firstname", "lastname", "canbook", "link", "actions"]'
                   cdkDrag [cdkDragData]="employee"></mat-row>
        </mat-table>
      </mat-card-content>
    </mat-card>
  </div>
}
